import React from 'react';
import IntroAdvertisementContainer from 'containers/IntroAdvertisementContainer';

export default function IntroAdvertisementPage() {
  return <IntroAdvertisementContainer />;
}
